import { useUserAgent } from './useUserAgent';

export const useIsSafari = () => {
  const userAgent = useUserAgent();
  return /^((?!chrome|android).)*safari/i.test(userAgent);
};
